const url = {url:'https://admin.museumofphilately.com/storage/'}
export default url
